@if (!editMode) {
  <h2 mat-dialog-title>
    Modul Rollenbatterie [NEU] hinzufügen
  </h2>
}
@if (editMode) {
  <h2 mat-dialog-title>Modul Rollenbatterie [NEU] editieren</h2>
}
<mat-dialog-content>
  <div>
    <form
      [formGroup]="roleBatteryForm"
      (ngSubmit)="updateOrCreateModule()"
      ngNativeValidate
      class="d-flex flex-column"
      >
      <mat-form-field>
        <mat-label>Überschrift</mat-label>
        <input matInput formControlName="headline" required />
      </mat-form-field>

      <mat-form-field>
        <mat-select required formControlName="datasource">
          @for (datasource of availableDataSources; track datasource) {
            <mat-option
              matInput
              [value]="datasource.influx_name"
              >{{ datasource.display_name }}</mat-option
              >
            }
          </mat-select>
          <mat-label>Datenquelle</mat-label>
        </mat-form-field>

        <button
          mat-raised-button
          color="primary"
          type="submit"
          [disabled]="!roleBatteryForm.valid || submitting"
          >
          @if (editMode) {
            Speichern
          }
          @if (!editMode) {
            Hinzufügen
          }
        </button>
      </form>
    </div>
  </mat-dialog-content>
